module.exports = __webpack_public_path__ + "static/media/tanoshii-trails.b29ed10c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/tanoshii-trails.jpg
// module id = 160
// module chunks = 0